﻿<template>
    <div class="vc-header">
        <div class="flex flex-wrap">
            <div class="flex-none justify-start items-center">
                <button type="button" class="vc-arrow arrow-left" :disabled="First_Month()" aria-label="Previous month" @click="previous_Month()">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
                </button>
            </div>
            <div class="flex-1 vc-title flex justify-center">
                <button type="button" class="select-button" @click="isOpen = !isOpen" :class="{'active': isOpen}" :aria-expanded="isOpen ? 'true' : 'false'" aria-label="Choose month">
                    <strong>{{format_month(selected_month)}}</strong>
                </button>
                <div class="select-dropdown w-80" v-if="isOpen">
                    <ul>
                        <li v-for="month in months" :key="key(month)"
                            :class="[ key(month) == key(selected_month) ? 'selected' : '' ]"
                            @click="month_selected(month)">
                            {{format_month(month)}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="flex-none justify-end items-center">
                <button type="button" class="vc-arrow arrow-right" :disabled="Last_Month()" aria-label="Next month" @click="next_Month()">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6" /></svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./calendar_month.ts"></script>